import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { DateTimePicker } from 'material-ui-pickers'
import moment from 'moment'
import Button from '@material-ui/core/Button'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormLabel from '@material-ui/core/FormLabel'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import RemoveIcon from '@material-ui/icons/RemoveCircle'
import { Field } from 'react-formality'
import ToggleButtonWithIcon from './components/ToggleButtonWithIcon'
import UploadImage from './components/UploadImage'
import FixedSizeImage from './components/FixedSizeImage'
import AddButton from './components/AddButton'
import temperatureTypes from './enums/temperatureTypes'
import entityTypes from './enums/entityTypes'
import errorTypes from './enums/errorTypes'
import messageTypes from './enums/messageTypes'
import weatherTypes from './enums/weatherTypes'
import Collection from './components/Collection'
import ExpandableSection from './components/ExpandableSection'
import icons from './enums/icons'
import connectPropTypes from './utilities/connectPropTypes'
import getPostTitle from './utilities/getPostTitle'
import serverTimestamp from './utilities/Data/serverTimestamp'
import getNormalisedParameters from './utilities/getNormalisedParameters'
import styles from './PostEdit.icss'
import Form from './components/Form'
import getDecodedURIComponent from './utilities/getDecodedURIComponent'

const maxTags = 20

const cap = str => str.charAt(0).toUpperCase() + str.slice(1)

class PostEdit extends React.Component {
	constructor(props) {
		super(props)
		const parsedSearch = getNormalisedParameters(this.props.location.search)
		this.state = {
			hasShownBottomBar: false,
			dialogShown: false,
			kitId: getDecodedURIComponent(parsedSearch.kitid || props.match.params.kitId),
			postId: getDecodedURIComponent(parsedSearch.postid || props.match.params.postId)
		}

		this.handleTagsUpdate = this.handleTagsUpdate.bind(this)
		this.handleUploadedImage = this.handleUploadedImage.bind(this)
		this.getTagsTitle = this.getTagsTitle.bind(this)
		this.bindHandleDeleteButtonClick = this.bindHandleDeleteButtonClick.bind(this)
		this.handleDialogDiscard = this.handleDialogDiscard.bind(this)
		this.handleDialogCancel = this.handleDialogCancel.bind(this)
	}

	componentDidMount() {
		this.props.appHeading({
			text: getPostTitle(this.props.user, this.props.postDraft && this.props.postDraft.timestamp ? new Date(this.props.postDraft.timestamp) : new Date()),
			icon: icons.whiteActivity
		})
		this.props.appShowBottomBar(false)
		this.props.appBottomNavBarHandleClick(() => {
			this.props.appNextButtonIsLoading(true)
			this.props.postSet({ postDraft: this.props.postDraft }, {
				success: ({ postId }) => {
					this.props.appNextButtonIsLoading(false)
					this.props.appRedirect(`/post/share${postId ? `/${postId}` : ''}`)
				},
				fail: () => {
					this.props.appNextButtonIsLoading(false)
				}
			})
		})
		this.props.appBottomNavBarLabelNext(this.context.translate('Share'))

		this.props.appBackButtonFunction(() => {
			if (this.props.postDraft) {
				this.setState({ dialogShown: true })
			} else {
				this.props.history.goBack()
			}
		})

		if (this.state.postId) {
			this.props.postDraftFetch({ postId: this.state.postId })
		} else {
			this.props.postDraftCreate()
		}
		if (!this.props.kitDraft && this.state.kitId) {
			this.props.postDraftKitFetch({ kitId: this.state.kitId })
		}
		this.mounted = true
	}

	componentDidUpdate() {
		if (this.props.postDraft && this.props.postDraft.tags && this.props.postDraft.tags.length > 0 && !this.state.hasShownBottomBar) {
			this.setState({ hasShownBottomBar: true }, () => this.props.appShowBottomNavBar(true)) // eslint-disable-line react/no-did-update-set-state
		}
	}

	componentWillUnmount() {
		if (this.state.deleteDraft) {
			this.props.postDraftDelete()
		}
		this.mounted = false
	}

	getTagsTitle(post) {
		const values = {
			numPeople: post.tags ? post.tags.filter(t => t.type === entityTypes.USER.type).length : 0
		}
		return this.context.translate('{numPeople|1 person tagged|# people tagged}', values)
	}

	handleUploadedImage(url) {
		this.props.postDraftSetImageUrl({ imageUrl: url })
		this.props.userProfileSetUploadedImage({ url })
	}

	handleUploadImageError() {
		this.props.appMessage(messageTypes.ERROR, this.context.translate('Image upload failed'), errorTypes.UNKNOWNERROR)
	}

	handleTagsUpdate(tags) {
		this.props.postDraftSetTags({ tags })
	}

	handleDialogDiscard() {
		this.setState({ dialogShown: false, deleteDraft: true })
		this.props.history.goBack()
	}

	handleDialogCancel() {
		this.setState({ dialogShown: false })
	}

	bindHandleDeleteButtonClick(thing) {
		return () => {
			this.props.postDraftRemoveTag({ thing })
		}
	}

	render() {
		const postDraft = this.props.postDraft

		if (!postDraft) {
			return null
		}

		const imageContent = postDraft.images && postDraft.images.length !== 0 ? postDraft.images : postDraft.imageUrl
		const addedTagCount = postDraft.tags ? postDraft.tags.length : 0
		const canAddTag = addedTagCount < maxTags

		const renderAfterItem = (renderProps) => {
			const aItem = renderProps.item
			return (
				<button
					key={`button${aItem.objectID}`}
					type="button"
					className={styles.addedTag}
					onClick={this.bindHandleDeleteButtonClick(aItem)}
				>
					<span>
						<RemoveIcon className={styles.removeTag} />
					</span>
				</button>
			)
		}

		//	Grab the first tagged kit image
		const kit = postDraft.kit || this.props.kitDraft
		const kitImage = (kit && (kit.images || kit.imageUrl))

		return !kit ? null : (
			<section>
				<div className={styles.post}>
					<section className={styles.images}>
						{kit &&
							<FixedSizeImage content={kitImage} className={styles.postImage} />
						}
						{imageContent &&
							<FixedSizeImage content={imageContent} className={styles.postImage} />
						}
						{!imageContent && (
							<UploadImage
								classNames={{ surround: styles.uploadImage }}
								saveUploadedImage={this.handleUploadedImage}
								errorHandler={this.handleUploadImageError}
								imageContent={imageContent}
								imgClass={styles.uploadedImage}
								imgInline={false}
								showHintText={false}
							/>
						)}
					</section>

					<section>
						<ExpandableSection title={this.getTagsTitle(postDraft)} defaultExpanded>
							<Collection
								classes={{ itemRoot: styles.itemRoot }}
								items={postDraft.tags.filter(tag => tag.type === entityTypes.USER.type)}
								itemTitle={i => i.text}
								itemSubtitle={i => i.description}
								itemImageContent={i => i.images}
								renderAfterItem={renderAfterItem}
							/>
						</ExpandableSection>
						<div className={styles.addButtonSurround}>
							{canAddTag &&
								<AddButton onClick={() => this.props.appRedirect(`/post/tag${this.state.kitId ? `?kitId=${this.state.kitId}` : ''}`)} className={styles.addButton}>{this.context.translate('Add someone')}</AddButton>
							}
							{!canAddTag &&
								<div className={styles.maxTagsReached}>{this.context.translate('You have added the maximum number of people ({maxTags})', { maxTags })}</div>
							}
						</div>
					</section>

					<Form
						initialValues={{
							dateTimestamp: new Date(),
							temperatureType: temperatureTypes.CELSIUS.type,
							...postDraft
						}}
					>
						{props => (
							<>
								<section className={styles.pagePadding}>
									<Field
										component={TextField}
										name="location"
										value={props.values.location}
										onChange={() => this.props.postDraftSet(props.store.values)}
										fullWidth
										multiline
										margin="normal"
										label={this.context.translate('Location')}
									/>
								</section>
								<section className={styles.pagePaddingSurround}>
									<div>
										<FormLabel filled classes={{ root: styles.timetakenLabel }}>{this.context.translate('Time taken')}</FormLabel>
									</div>
									<div>
										{this.context.translate('{hourSelector} hours {minuteSelector} minutes', {
											hourSelector: {
												value: props.values.timeTakenHours,
												display: () => (
													<Field
														component={Select}
														name="timeTakenHours"
														value={props.values.timeTakenHours}
														onChange={e => this.props.postDraftSet({ ...props.store.values, timeTakenHours: e.target.value })}
														label={this.context.translate('Hours taken')}
													>
														{[...Array(25).keys()].map(hour => <MenuItem key={hour} value={hour}>{hour.toString()}</MenuItem>)}
														<MenuItem key="24+" value="24+">{this.context.translate('24+')}</MenuItem>
													</Field>
												)
											},
											minuteSelector: {
												value: props.values.timeTakenMinutes,
												display: value => (
													<Field
														component={Select}
														name="timeTakenMinutes"
														value={value}
														onChange={e => this.props.postDraftSet({ ...props.store.values, timeTakenMinutes: e.target.value })}
														label={this.context.translate('Minutes taken')}
													>
														{[...Array(60).keys()].map(minute => <MenuItem key={minute} value={minute}>{minute.toString()}</MenuItem>)}
													</Field>
												)
											}
										})}
									</div>
								</section>
								<section className={styles.pagePadding}>
									<Field
										classes={{ root: styles.datepickerSurround }}
										component={DateTimePicker}
										name="dateTimestamp"
										format="HH:mma ddd DD/MM/YY"
										value={moment(serverTimestamp(props.values.dateTimestamp)).toDate()}
										getComponentValue={date => moment(date).toDate()}
										onChange={value => this.props.postDraftSet({ ...props.store.values, dateTimestamp: value.toDate() })}
										label={this.context.translate('When')}
									/>
								</section>
								<section className={styles.pagePaddingSurround}>
									<div>
										<FormLabel filled classes={{ root: styles.timetakenLabel }}>{this.context.translate('Conditions')}</FormLabel>
									</div>
									<div className={styles.weatherSurround}>
										{Object.keys(weatherTypes).map(wt => (
											<ToggleButtonWithIcon
												key={wt}
												title={weatherTypes[wt].name}
												value={props.values[wt]}
												iconNameOff={`black${cap(wt)}`}
												iconNameOn={`red${cap(wt)}`}
												onChange={selected => this.props.postDraftSet({ ...props.store.values, [wt]: selected })}
											/>
										))}
									</div>
									<div>
										{this.context.translate('Low {lowSelector} High {highSelector} in {temperatureTypeSelector}', {
											lowSelector: {
												value: props.values.lowTemperature,
												display: (value) => {
													const isCelsius = props.values.temperatureType === temperatureTypes.CELSIUS.type
													return (
														<Field
															key={`low${props.values.temperatureType}-${value}`}
															component={Select}
															name="lowTemperature"
															value={value}
															onChange={e => this.props.postDraftSet({ ...props.store.values, lowTemperature: e.target.value })}
															label={this.context.translate('Low temperature')}
														>
															<MenuItem key="temperatureLowest" value="temperatureLowest">{isCelsius ? this.context.translate('-25 or below') : this.context.translate('-13 or below')}</MenuItem>
															{isCelsius && [...Array(69).keys()].map(degrees => <MenuItem key={(degrees - 24)} value={(degrees - 24)}>{(degrees - 24).toString()}</MenuItem>)}
															{!isCelsius && [...Array(125).keys()].map(degrees => <MenuItem key={(degrees - 12)} value={(degrees - 12)}>{(degrees - 12).toString()}</MenuItem>)}
															<MenuItem key="temperatureHighest" value="temperatureHighest">{isCelsius ? this.context.translate('45 or above') : this.context.translate('113 or above')}</MenuItem>
														</Field>
													)
												}
											},
											highSelector: {
												value: props.values.highTemperature,
												display: (value) => {
													const isCelsius = props.values.temperatureType === temperatureTypes.CELSIUS.type
													return (
														<Field
															key={`high${props.values.temperatureType}-${value}`}
															component={Select}
															name="highTemperature"
															value={props.values.highTemperature}
															onChange={e => this.props.postDraftSet({ ...props.store.values, highTemperature: e.target.value })}
															label={this.context.translate('High temperature')}
														>
															<MenuItem key="temperatureLowest" value="temperatureLowest">{isCelsius ? this.context.translate('-25 or below') : this.context.translate('-13 or below')}</MenuItem>
															{isCelsius && [...Array(69).keys()].map(degrees => <MenuItem key={(degrees - 24)} value={(degrees - 24)}>{(degrees - 24).toString()}</MenuItem>)}
															{!isCelsius && [...Array(125).keys()].map(degrees => <MenuItem key={(degrees - 12)} value={(degrees - 12)}>{(degrees - 12).toString()}</MenuItem>)}
															<MenuItem key="temperatureHighest" value="temperatureHighest">{isCelsius ? this.context.translate('45 or above') : this.context.translate('113 or above')}</MenuItem>
														</Field>
													)
												}
											},
											temperatureTypeSelector: {
												value: props.values.temperatureType,
												display: value => (
													<Field
														component={Select}
														name="temperatureType"
														value={value}
														onChange={(e) => {
															const temperatureType = e.target.value
															//	Update the other selectors if they have value
															const lowTemperature = temperatureTypes[temperatureType].fromOtherTemperature(props.store.values.lowTemperature)
															const highTemperature = temperatureTypes[temperatureType].fromOtherTemperature(props.store.values.highTemperature)
															//	Set the target value
															this.props.postDraftSet({ ...props.store.values, lowTemperature, highTemperature, temperatureType })
															//	Set the values in the store
															props.store.set({ lowTemperature, highTemperature, temperatureType })
														}}
														label={this.context.translate('High temperature')}
													>
														<MenuItem key={temperatureTypes.CELSIUS.type} value={temperatureTypes.CELSIUS.type}>{this.context.translate('Celsius')}</MenuItem>
														<MenuItem key={temperatureTypes.FAHRENHEIT.type} value={temperatureTypes.FAHRENHEIT.type}>{this.context.translate('‎Fahrenheit')}</MenuItem>
													</Field>
												)
											}
										})}
									</div>
								</section>
								<section className={styles.pagePadding}>
									<Field
										component={TextField}
										name="caption"
										value={props.values.caption}
										onChange={() => this.props.postDraftSet(props.store.values)}
										fullWidth
										multiline
										margin="normal"
										label={this.context.translate('Post caption')}
									/>
								</section>
							</>
						)}
					</Form>
				</div>
				<Dialog
					open={this.state.dialogShown}
					onClose={this.handleDialogClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{this.context.translate('Discard post?')}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{this.context.translate('Do you want to keep your post, or discard it?')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleDialogDiscard} color="primary">
							{this.context.translate('Discard')}
						</Button>
						<Button onClick={this.handleDialogCancel} color="primary" autoFocus>
							{this.context.translate('Keep post')}
						</Button>
					</DialogActions>
				</Dialog>
			</section>
		)
	}
}

PostEdit.contextTypes = {
	translate: PropTypes.func
}

PostEdit.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
		search: PropTypes.string
	}).isRequired,
	match: PropTypes.shape({
		params: PropTypes.object.isRequired
	}).isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired,
	appHeading: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	appMessage: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appNextButtonIsLoading: PropTypes.func.isRequired,
	appBackButtonFunction: PropTypes.func.isRequired,
	userProfileSetUploadedImage: PropTypes.func.isRequired,
	postDraftSet: PropTypes.func.isRequired,
	postDraftSetImageUrl: PropTypes.func.isRequired,
	postDraftRemoveTag: PropTypes.func.isRequired,
	postDraftSetTags: PropTypes.func.isRequired,
	postSet: PropTypes.func.isRequired,
	postDraft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	kitDraft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	postDraftFetch: PropTypes.func.isRequired,
	postDraftKitFetch: PropTypes.func.isRequired,
	postDraftCreate: PropTypes.func.isRequired,
	postDraftDelete: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
}

PostEdit.defaultProps = {
	postDraft: undefined,
	kitDraft: undefined
}

export const testing = {
	PostEdit
}

export default connectPropTypes(PostEdit)



// WEBPACK FOOTER //
// ./src/PostEdit.jsx